import { Injectable } from '@angular/core';
import { Load } from './model/load';
import _ from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class LoadService {
    setAdditivesHtml(loads: Load[]) {
        if (!loads || loads.length === 0) return;

        const columnHeaders = ['Name', 'Qty'];
        loads.forEach((load) => {
            const hasAdditives = load.loadAdditives && load.loadAdditives.length > 0;
            if (!hasAdditives) return;

            load.loadAdditivesHtml = `<table class="html-table">
                <thead><tr><th><b>${columnHeaders.join('</b></th><th><b>')}</b></th></tr></thead>
                <tbody>${this.getAdditivesHtml(load)}</tbody>
            </table>`;
        });
    }

    private getAdditivesHtml(load: Load) {
        if (!load.loadAdditives || load.loadAdditives.length === 0) return '';

        let html = '';
        _(load.loadAdditives)
            .filter((additive) => !additive.deleted)
            .orderBy((additive) => [additive.displayOrder, additive.abbreviation, additive.name])
            .forEach((additive) => {
                const cells = [`${additive.abbreviation} - ${additive.name}`, additive.loadYards];
                html += `<tr><td>${cells.join('</td><td>')}</td></tr>`;
            });
        return html;
    }

    isTaxable(load: Load) {
        if (load.customer.taxCodeId && !load.customer.taxCode.isTaxable) return false;
        return load.product.category.isTaxable;
    }
}
